import { render, staticRenderFns } from "./CertificateVerification.vue?vue&type=template&id=28fccc6c&scoped=true"
import script from "./CertificateVerification.vue?vue&type=script&lang=js"
export * from "./CertificateVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fccc6c",
  null
  
)

export default component.exports